import React, { useMemo, useState } from "react";
import { Modal, Table, ScrollArea, TextInput } from "@mantine/core";

type Props = {
  opened: boolean;
  onClose: () => void;
  title: string;
  rows: any[];
  nameKey: string; // e.g. "district_Name"
  nameLabel: string; // e.g. "District"
};

export default function ViewAllModal({
  opened,
  onClose,
  title,
  rows,
  nameKey,
  nameLabel,
}: Props) {
  const [search, setSearch] = useState("");

  const data = useMemo(() => {
    return (rows ?? [])
      .filter((r) => r?.[nameKey] && String(r[nameKey]).trim() !== "") // drop the empty "-1" row
      .filter((r) =>
        String(r[nameKey]).toLowerCase().includes(search.toLowerCase()),
      )
      .sort((a, b) => (b.postTestAverage ?? 0) - (a.postTestAverage ?? 0));
  }, [rows, nameKey, search]);

  return (
    <Modal
      opened={opened}
      onClose={() => {
        setSearch("");
        onClose();
      }}
      title={<span className="font-semibold">{title}</span>}
      size="xl"
      centered
    >
      <TextInput
        placeholder={`Search ${nameLabel.toLowerCase()}`}
        value={search}
        onChange={(e) => setSearch(e.currentTarget.value)}
        className="mb-3"
      />
      <ScrollArea style={{ height: 420 }}>
        <Table highlightOnHover striped verticalSpacing="xs">
          <thead
            style={{
              position: "sticky",
              top: 0,
              background: "#fff",
              zIndex: 1,
            }}
          >
            <tr>
              <th>#</th>
              <th>{nameLabel}</th>
              <th>Teachers</th>
              <th>Avg Pre Test</th>
              <th>Avg Post Test</th>
              <th>Learning Gain</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            ) : (
              data.map((r, i) => {
                const gain = (r.postTestAverage ?? 0) - (r.preTestAverage ?? 0);
                return (
                  <tr key={r.district_Id ?? r.block_Id ?? i}>
                    <td>{i + 1}</td>
                    <td>{r[nameKey]}</td>
                    <td>{r.totalTeachers ?? 0}</td>
                    <td>{r.preTestAverage ?? 0}%</td>
                    <td>{r.postTestAverage ?? 0}%</td>
                    <td
                      style={{
                        color: gain >= 0 ? "#16a34a" : "#ef4444",
                        fontWeight: 600,
                      }}
                    >
                      {gain > 0 ? "+" : ""}
                      {gain}%
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </ScrollArea>
    </Modal>
  );
}
